/* eslint-disable camelcase */
const CombinedAvgAndPeak = ({ textData: { avg_combined_occupancy, peak_combined_occupancy } }) =>
  `The average combined office occupancy was ${Math.round(avg_combined_occupancy)} people
   with a peak of ${Math.round(peak_combined_occupancy)} people.`;

export default CombinedAvgAndPeak;
